// // src/services/syncService.js
// import { productsAPI } from '../api/products';
// import { warehousesAPI } from '../api/warehouses';
// import { ordersAPI } from '../api/orders';
// import { customersAPI } from '../api/customers';
// import { stocksAPI } from '../api/stocks';
// import { getTeamMembers, addTeamMember, updateTeamMember, deleteTeamMember } from '../api/team';
// import { dbHelpers } from '../db/database';
// import apiClient from '../api/client';

// class SyncService {
//   constructor() {
//     this.isSyncing = false;
//     this.syncInProgress = false;
//     this.lastSyncTime = null;
    
//     // ⭐ Setup auto-sync on reconnect
//     this.setupAutoSync();
//   }

//   // ⭐ NEW: Auto-sync when coming back online
//   setupAutoSync() {
//     // Listen for online event
//     window.addEventListener('online', async () => {
      
//       // Wait 1 second for connection to stabilize
//       setTimeout(async () => {
//         try {
//           await this.fullSync();
          
//           // Show success notification if available
//           if (window.showToast) {
//             window.showToast('✅ Synced successfully!', 'success');
//           } else {
//           }
//         } catch (error) {
//         }
//       }, 1000);
//     });

//     // ⭐ Also sync when user returns to the app
//     document.addEventListener('visibilitychange', async () => {
//       if (!document.hidden && navigator.onLine) {
//         const timeSinceLastSync = Date.now() - (this.lastSyncTime || 0);
        
//         // Sync if more than 5 minutes since last sync
//         if (timeSinceLastSync > 5 * 60 * 1000) {
//           await this.quickSync();
//         }
//       }
//     });
//   }

//   async fullSync() {
//     if (!navigator.onLine) {
//       return { success: false, message: 'No internet connection' };
//     }

//     if (this.syncInProgress) {
//       return { success: false, message: 'Sync already in progress' };
//     }

//     this.syncInProgress = true;
//     let productsCount = 0;
//     let warehousesCount = 0;
//     let ordersCount = 0;
//     let stocksCount = 0;
//     let customersCount = 0;
//     let teamMembersCount = 0;

//     try {

//       // STEP 1: Sync pending changes FIRST (push local changes to server)
//       await this.syncPendingChanges();

//       // STEP 2: Pull latest data from server
//       // 1. Sync products
//       const productsResponse = await productsAPI.getAll();
//       let products = [];
//       if (productsResponse.results) {
//         products = productsResponse.results;
//       } else if (productsResponse.data?.results) {
//         products = productsResponse.data.results;
//       } else if (Array.isArray(productsResponse)) {
//         products = productsResponse;
//       }
//       productsCount = products.length;
//       if (products.length > 0) {
//         await dbHelpers.saveProducts(products);
//       }

//       // 2. Sync warehouses
//       const warehousesResponse = await warehousesAPI.getAll();
//       let warehouses = [];
//       if (warehousesResponse.results) {
//         warehouses = warehousesResponse.results;
//       } else if (warehousesResponse.data?.results) {
//         warehouses = warehousesResponse.data.results;
//       } else if (Array.isArray(warehousesResponse)) {
//         warehouses = warehousesResponse;
//       }
//       warehousesCount = warehouses.length;
//       if (warehouses.length > 0) {
//         await dbHelpers.saveWarehouses(warehouses);
//       }

//       // 3. Sync stocks
//       const stocksResponse = await stocksAPI.getAll();
//       let stocks = [];
//       if (stocksResponse.results) {
//         stocks = stocksResponse.results;
//       } else if (stocksResponse.data?.results) {
//         stocks = stocksResponse.data.results;
//       } else if (Array.isArray(stocksResponse)) {
//         stocks = stocksResponse;
//       }
//       stocksCount = stocks.length;
//       if (stocks.length > 0) {
//         await dbHelpers.saveStocks(stocks);
//       }

//       // 4. Sync customers
//       const customersResponse = await customersAPI.getAll();
//       let customers = [];
//       if (customersResponse.results) {
//         customers = customersResponse.results;
//       } else if (customersResponse.data?.results) {
//         customers = customersResponse.data.results;
//       } else if (Array.isArray(customersResponse)) {
//         customers = customersResponse;
//       }
//       customersCount = customers.length;
//       if (customers.length > 0) {
//         await dbHelpers.saveCustomers(customers);
//       }

//       // 5. Sync orders
//       const ordersResponse = await ordersAPI.getAll();
//       let orders = [];
//       if (ordersResponse.results) {
//         orders = ordersResponse.results;
//       } else if (ordersResponse.data?.results) {
//         orders = ordersResponse.data.results;
//       } else if (Array.isArray(ordersResponse)) {
//         orders = ordersResponse;
//       }
//       ordersCount = orders.length;
//       if (orders.length > 0) {
//         await dbHelpers.saveOrders(orders);
//       }

//       // 6. Sync team members
//       try {
//         const teamMembers = await getTeamMembers();
//         teamMembersCount = teamMembers.length;
//         if (teamMembers.length > 0) {
//           await dbHelpers.saveTeamMembers(teamMembers);
//         }
//       } catch (err) {
//       }

//       // 7. Save last sync time
//       this.lastSyncTime = Date.now();
//       await dbHelpers.setSetting('last_sync_time', this.lastSyncTime);

//       // Dispatch sync completed event
//       window.dispatchEvent(new Event('sync-completed'));
      
//       this.syncInProgress = false;

//       return {
//         success: true,
//         message: 'Sync completed successfully',
//         stats: {
//           products: productsCount,
//           warehouses: warehousesCount,
//           stocks: stocksCount,
//           customers: customersCount,
//           orders: ordersCount,
//           teamMembers: teamMembersCount
//         }
//       };
//     } catch (error) {
//       this.syncInProgress = false;
//       return { success: false, message: error.message };
//     }
//   }

//   // ⭐ IMPROVED: Sync pending changes including deletes
//   async syncPendingChanges() {
//     // Get both sync_queue and pendingChanges
//     const queuedChanges = await dbHelpers.getUnsyncedItems();
//     const pendingChanges = await dbHelpers.getPendingChanges();
    
//     const totalChanges = queuedChanges.length + pendingChanges.length;

//     if (totalChanges === 0) {
//       return;
//     }

//     // Sync queued changes (create/update)
//     const syncedIds = [];
//     for (const change of queuedChanges) {
//       try {
//         await this.syncChange(change);
//         syncedIds.push(change.id);
//       } catch (error) {
//       }
//     }

//     if (syncedIds.length > 0) {
//       await dbHelpers.markAsSynced(syncedIds);
//     }

//     // ⭐ Sync pending deletes
//     for (const change of pendingChanges) {
//       if (change.type === 'DELETE') {
//         try {
//           await this.syncDelete(change);
//           await dbHelpers.clearPendingChange(change.id);
//         } catch (error) {
//         }
//       }
//     }
//   }

//   // ⭐ NEW: Sync delete operations
//   async syncDelete(change) {
//     const { storeName, itemId } = change;

//     try {
//       if (storeName === 'products') {
//         await apiClient.delete(`/products/${itemId}/`);
//       } else if (storeName === 'stocks') {
//         await apiClient.delete(`/stocks/${itemId}/`);
//       } else if (storeName === 'warehouses') {
//         await apiClient.delete(`/warehouses/${itemId}/`);
//       } else if (storeName === 'customers') {
//         await apiClient.delete(`/customers/${itemId}/`);
//       } else if (storeName === 'orders') {
//         await apiClient.delete(`/orders/${itemId}/`);
//       } else if (storeName === 'team_members') {
//         await deleteTeamMember(itemId);
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         // Already deleted on server - that's fine
//       } else {
//         throw error;
//       }
//     }
//   }

//   async syncChange(change) {
//     const { entity_type, entity_id, action, data } = change;

//     switch (entity_type) {
//       case 'customer':
//         if (action === 'update') {
//           await customersAPI.update(entity_id, data);
//         } else if (action === 'delete') {
//           await customersAPI.delete(entity_id);
//         } else if (action === 'create') {
//           await customersAPI.create(data);
//         }
//         break;

//       case 'product':
//         if (action === 'update') {
//           await productsAPI.update(entity_id, data);
//         } else if (action === 'delete') {
//           await productsAPI.delete(entity_id);
//         } else if (action === 'create') {
//           await productsAPI.create(data);
//         }
//         break;

//       case 'order':
//         if (action === 'update') {
//           await ordersAPI.update(entity_id, data);
//         } else if (action === 'delete') {
//           await ordersAPI.delete(entity_id);
//         } else if (action === 'create') {
//           await ordersAPI.create(data);
//         }
//         break;

//       case 'team_members':
//         if (action === 'update') {
//           await updateTeamMember(entity_id, data);
//         } else if (action === 'delete') {
//           await deleteTeamMember(entity_id);
//         } else if (action === 'create') {
//           await addTeamMember(data);
//         }
//         break;

//       case 'stock_transfer':
//         if (action === 'create') {
//           await stocksAPI.transfer(data);
//         }
//         break;

//       default:
//     }
//   }

//   // ⭐ NEW: Quick sync (lighter than full sync)
//   async quickSync() {
//     if (this.isSyncing || !navigator.onLine) return;
    
//     this.isSyncing = true;
    
//     try {
//       await this.syncPendingChanges();
//       this.lastSyncTime = Date.now();
//       await dbHelpers.setSetting('last_sync_time', this.lastSyncTime);
//     } catch (error) {
//     } finally {
//       this.isSyncing = false;
//     }
//   }

//   async getLastSyncTime() {
//     if (!this.lastSyncTime) {
//       this.lastSyncTime = await dbHelpers.getSetting('last_sync_time', null);
//     }
//     return this.lastSyncTime;
//   }

//   // Legacy method - keep for backward compatibility
//   startAutoSync() {
//     // Already handled in constructor
//   }
// }

// const syncServiceInstance = new SyncService();

// export default syncServiceInstance;



// src/services/syncService.js
import { productsAPI } from '../api/products';
import { warehousesAPI } from '../api/warehouses';
import { ordersAPI } from '../api/orders';
import { customersAPI } from '../api/customers';
import { stocksAPI } from '../api/stocks';
import { getTeamMembers, addTeamMember, updateTeamMember, deleteTeamMember } from '../api/team';
import { dbHelpers } from '../db/database';
import apiClient from '../api/client';

class SyncService {
  constructor() {
    this.isSyncing = false;
    this.syncInProgress = false;
    this.lastSyncTime = null;
    this.setupAutoSync();
  }

  setupAutoSync() {
    window.addEventListener('online', async () => {
      setTimeout(async () => {
        try {
          await this.fullSync();
          if (window.showToast) {
            window.showToast('✅ Synced successfully!', 'success');
          }
        } catch (error) {}
      }, 1000);
    });

    document.addEventListener('visibilitychange', async () => {
      if (!document.hidden && navigator.onLine) {
        const timeSinceLastSync = Date.now() - (this.lastSyncTime || 0);
        if (timeSinceLastSync > 5 * 60 * 1000) {
          await this.quickSync();
        }
      }
    });
  }

  async fullSync() {
    if (!navigator.onLine) {
      return { success: false, message: 'No internet connection' };
    }
    if (this.syncInProgress) {
      return { success: false, message: 'Sync already in progress' };
    }

    this.syncInProgress = true;
    let counts = { products: 0, warehouses: 0, orders: 0, stocks: 0, customers: 0, teamMembers: 0 };

    try {
      // STEP 1: Push pending local changes to server first
      await this.syncPendingChanges();

      // STEP 2: Pull latest data from server
      const pull = async (apiFn, saveFn, countKey, normalize) => {
        const response = await apiFn();
        const data = normalize(response);
        counts[countKey] = data.length;
        if (data.length > 0) await saveFn(data);
      };

      const norm = r => r?.data?.results || r?.data || (Array.isArray(r) ? r : []);

      await pull(() => productsAPI.getAll(),   dbHelpers.saveProducts.bind(dbHelpers),   'products',   norm);
      await pull(() => warehousesAPI.getAll(),  dbHelpers.saveWarehouses.bind(dbHelpers), 'warehouses', norm);
      await pull(() => stocksAPI.getAll(),      dbHelpers.saveStocks.bind(dbHelpers),     'stocks',     norm);
      await pull(() => customersAPI.getAll(),   dbHelpers.saveCustomers.bind(dbHelpers),  'customers',  norm);
      await pull(() => ordersAPI.getAll(),      dbHelpers.saveOrders.bind(dbHelpers),     'orders',     norm);

      // Team members use a different API shape
      try {
        const teamMembers = await getTeamMembers();
        counts.teamMembers = teamMembers.length;
        if (teamMembers.length > 0) await dbHelpers.saveTeamMembers(teamMembers);
      } catch (err) {
        console.warn('Team sync failed:', err.message);
      }

      this.lastSyncTime = Date.now();
      await dbHelpers.setSetting('last_sync_time', this.lastSyncTime);
      window.dispatchEvent(new Event('sync-completed'));
      this.syncInProgress = false;

      return { success: true, message: 'Sync completed successfully', stats: counts };
    } catch (error) {
      this.syncInProgress = false;
      return { success: false, message: error.message };
    }
  }

  async syncPendingChanges() {
    const queuedChanges = await dbHelpers.getUnsyncedItems();
    const pendingChanges = await dbHelpers.getPendingChanges();

    // Push create/update changes
    const syncedIds = [];
    for (const change of queuedChanges) {
      try {
        await this.syncChange(change);
        syncedIds.push(change.id);
      } catch (error) {
        console.warn(`Failed to sync ${change.entity_type} ${change.entity_id}:`, error.message);
      }
    }
    if (syncedIds.length > 0) await dbHelpers.markAsSynced(syncedIds);

    // ✅ Push pending deletes
    for (const change of pendingChanges) {
      if (change.type === 'DELETE') {
        try {
          await this.syncDelete(change.storeName, change.itemId);
          await dbHelpers.clearPendingChange(change.id);
        } catch (error) {
          // 404 means already deleted on server — clear it anyway
          if (error.response?.status === 404) {
            await dbHelpers.clearPendingChange(change.id);
          } else {
            console.warn(`Failed to sync delete ${change.storeName}:${change.itemId}:`, error.message);
          }
        }
      }
    }
  }

  // ✅ Fixed: uses storeName + itemId (matching markForDeletion format)
  async syncDelete(storeName, itemId) {
    const endpointMap = {
      products:     `/products/${itemId}/`,
      stocks:       `/stocks/${itemId}/`,
      warehouses:   `/warehouses/${itemId}/`,
      customers:    `/customers/${itemId}/`,
      orders:       `/orders/${itemId}/`,
    };

    if (storeName === 'team_members') {
      await deleteTeamMember(itemId);
    } else if (endpointMap[storeName]) {
      await apiClient.delete(endpointMap[storeName]);
    } else {
      console.warn(`Unknown storeName for delete sync: ${storeName}`);
    }
  }

  async syncChange(change) {
    const { entity_type, entity_id, action, data } = change;

    const handlers = {
      customer:      { update: customersAPI.update, delete: customersAPI.delete, create: customersAPI.create },
      product:       { update: productsAPI.update,  delete: productsAPI.delete,  create: productsAPI.create },
      order:         { update: ordersAPI.update,    delete: ordersAPI.delete,    create: ordersAPI.create },
      team_members:  { update: updateTeamMember,    delete: deleteTeamMember,    create: addTeamMember },
    };

    const handler = handlers[entity_type];
    if (!handler) return;

    if (action === 'update' || action === 'delete') {
      await handler[action](entity_id, data);
    } else if (action === 'create') {
      await handler.create(data);
    } else if (entity_type === 'stock_transfer' && action === 'create') {
      await stocksAPI.transfer(data);
    }
  }

  async quickSync() {
    if (this.isSyncing || !navigator.onLine) return;
    this.isSyncing = true;
    try {
      await this.syncPendingChanges();
      this.lastSyncTime = Date.now();
      await dbHelpers.setSetting('last_sync_time', this.lastSyncTime);
    } catch (error) {
      console.warn('Quick sync failed:', error.message);
    } finally {
      this.isSyncing = false;
    }
  }

  async getLastSyncTime() {
    if (!this.lastSyncTime) {
      this.lastSyncTime = await dbHelpers.getSetting('last_sync_time', null);
    }
    return this.lastSyncTime;
  }

  startAutoSync() {} // kept for backward compat
}

const syncServiceInstance = new SyncService();
export default syncServiceInstance;